const STALE_TIME = Infinity

export { STALE_TIME }
